import * as swcHelpers from '@swc/helpers';
import { OrderDeliveryMethod } from '../../../../__generated__/sharedTypes.js';
import { DeliveryMethod } from '../../../models/details-order.js';

const toOrderDetailPrice = (raw)=>{
    return {
        totalPrice: raw.total,
        shippingMethodPrice: raw.shippingPrice,
        paymentMethodPrice: raw.paymentMethodPrice || undefined,
        discountedAmount: raw.discountedAmount || 0,
        subtotalAmount: raw.subtotal || 0
    };
};
const toAddress = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const fieldNames = [
        'firstName',
        'lastName',
        'streetName',
        'streetNumber',
        'additionalStreetInfo',
        'city',
        'postalCode',
        'region',
        'countryCode',
        'externalId', 
    ];
    if (raw.__typename === 'OrderAddress') {
        var _fieldName;
        return fieldNames.reduce((m, fieldName)=>swcHelpers.objectSpread({}, m, {
                [fieldName]: (_fieldName = raw[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : ''
            })
        , {});
    }
};
const toOrderDeliveryMethod = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const labelMapping = {
        [OrderDeliveryMethod.HOME_DELIVERY]: DeliveryMethod.HomeDelivery,
        [OrderDeliveryMethod.HOME_DELIVERY_EXPRESS]: DeliveryMethod.HomeDeliveryExpress,
        [OrderDeliveryMethod.NEAREST_PICK_UP]: DeliveryMethod.NearestPickUp,
        [OrderDeliveryMethod.PICK_UP]: DeliveryMethod.PickUp,
        [OrderDeliveryMethod.PICK_UP_POINT]: DeliveryMethod.PickupPoint
    };
    return labelMapping[raw];
};

export { toAddress, toOrderDeliveryMethod, toOrderDetailPrice };
//# sourceMappingURL=orders.js.map
